// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-3564f987]{position:relative;margin:0 auto;width:610px;padding:120px 0}.error_content .error__img[data-v-3564f987]{width:610px}.error_content .error__img img[data-v-3564f987]{width:100%;height:auto;vertical-align:top}.error_content a[data-v-3564f987]{position:relative;margin:60px auto 0;display:block;width:180px;height:60px;border-radius:4px;border:1px solid #f63232;text-align:center;line-height:60px;font-size:24px;color:#f63232}", ""]);
// Exports
module.exports = exports;
